<template>
  <li class="timeline-item ">
    <div class="timeline-badge bg-white">
<!--      <icon  v-bind:name="{'registered': statusRegistered,'tick': statusSuccess, 'cross': statusCancellation,'progress': !statusSuccess && !statusCancellation && !statusRegistered }" class="h-6 mb-2 inline fill-white"></icon>-->
      <icon name="paid" class="h-8 mb-2 inline fill-white"></icon>
    </div>
    <div class="timeline-panel ">



      <div class="timeline-heading">
        <h4 class="timeline-title">
          <span class="mx-0.5 px-2 py-1 rounded-md text-white bg-green-900">
          Likuiduar
        </span>
        </h4>
        <div class="timeline-panel-controls">
          <div class="timestamp">
            <small >{{ item.hr_created_at }}</small>
            <br>
            <small >{{ item.user }}</small>
          </div>
        </div>
      </div>
      <div class="timeline-body mt-5">Kthimi i mjeteve është likuiduar. Gjurmo barazimin me këtë ID: {{item.id}}</div>

    </div>
  </li>
</template>

<script>
import Icon from '@/Shared/Icon'

export default {
  name: 'MoneyReturnLikuiduarTimelineItem',
  components: {
    Icon
  },
  props: {
    item: Object,
  },
}
</script>
